import { SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_250 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
export const SearchWrapper = styled.div `
  width: 100%;
  margin-bottom: ${({ $compare }) => ($compare ? SYS_SPACE_FIXED_250 : 0)};

  @media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
    width: 290px;
    margin-bottom: 0;
  }
`;
